import React from "react"
import { Button, FormControl, FormGroup, Glyphicon, InputGroup } from "react-bootstrap"


export default function Option(props) {
  // PROPS
  const {
    option,
    question,
    editOption,
    removeOption,
    formErrors
  } = props

  return (
    <div className="option-row">
      <FormGroup validationState={
        (formErrors[question.id] && formErrors[question.id]['options'])
        || (formErrors[option.id] && formErrors[option.id]['name'])
          ?
          'error' : null
      } style={{ marginBottom: "0px" }}>
        <InputGroup>
          <InputGroup.Addon
            style={{ cursor: "pointer" }}
            onClick={() => editOption(question.id, option.id, "is_correct", !option.is_correct)}
          >
            <input
              style={{ cursor: "pointer" }}
              type={ question.type === "Multiselect" ? "checkbox" : "radio"}
              checked={ option.is_correct }
              onChange={ () => null }
            />
          </InputGroup.Addon>
          <FormControl
            value={ option.name }
            disabled={ question.type === "Boolean" }
            onChange={ (e) => editOption(question.id, option.id, "name", e.target.value) }
          />
          { question.type !== "Boolean" && question.options.length > 2 ?
            <InputGroup.Button onClick={ () => removeOption(question.id, option.id) }>
              <Button bsStyle="danger">
                <Glyphicon glyph="trash" />
              </Button>
            </InputGroup.Button> : null
          }
        </InputGroup>
      </FormGroup>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/EditAssessmentModal/Option.js